import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import EventPage from './event/EventPage';
import './Melismes.scss';
import ProgramPage from './program/ProgramPage';
import ResourcePage from './resource/ResourcePage';
import Welcome from './Welcome';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <ProgramPage isActive={navigationContext.acitveAppKey === 'program'} />
        <ResourcePage isActive={navigationContext.acitveAppKey === 'resource'} />
        <EventPage isActive={navigationContext.acitveAppKey === 'msevent'} />
        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
